<div
  [id]="id"
  class="card esri-widget animation-on-tool-open"
  #searchParzelleComponentRef
>
  <!--- the card header -->
  <div class="card-header">
    <div class="row">
      <div class="col-md-9" translate>
       {{searchConfig.widget_title}}
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>

  <!-- the card body -->
  <div class="card-body">
    <form [formGroup]="formGroup">
      <div class="form-row">
        <!--- Gemeinde -->
        <div class="form-group col-12">
          <label for="taGemeinde" translate>LIST_VIEW.TEILPARTZELLEN.GEMEINDE</label>
          <input
            #gemeindeRef
            autocomplete="off"
            id="taGemeinde"
            name="taGemeinde"
            [formControl]="formGroup.controls['taGemeinde']"
            [(ngModel)]="this.searchTextGemeinde"
            [typeahead]="this.searchListGemeinde"
            [typeaheadOptionField]="'name'"
            [typeaheadWaitMs]="100"
            [typeaheadMinLength]="2"
            (typeaheadLoading)="_typeaheadService.onSearchLoading($event)"
            (typeaheadNoResults)="_typeaheadService.onSearchNoResults($event)"
            (typeaheadOnSelect)="_typeaheadService.onSearchSelect($event)"
            (change)="clearParzellenField()"
            placeholder="Gemeinde ..."
            class="form-control form-control-sm"
          />
        </div>

        <!--- Parzelle -->
        <div class="form-group col-12">
          <label for="taParzelle" translate>{{searchConfig.sbb_grundstueck_label}}</label>
          <input
            #parzelleRef
            autocomplete="off"
            id="taParzelle"
            name="taParzelle"
            [formControl]="formGroup.controls['taParzelle']"
            [(ngModel)]="this.searchTextParzelleNr"
            [typeahead]="this.searchListParzellenNr"
            [typeaheadOptionField]="'name'"
            [typeaheadWaitMs]="100"
            [typeaheadMinLength]="1"
            (typeaheadLoading)="_typeaheadService.onSearchLoading($event)"
            (typeaheadNoResults)="_typeaheadService.onSearchNoResults($event)"
            (typeaheadOnSelect)="_typeaheadService.onSearchSelect($event)"
            placeholder="Parzellennr...."
            class="form-control form-control-sm"
          />
        </div>

        <!--- buttons -->
        <div class="form-group col-12">
          <button class="btn btn-primary btn-block" (click)="searchParzelle()" translate>
            <span class="esri-icon-locate"></span>
            COMMON.SEARCH_BUTTON_TEXT
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
